import VehicleBlockSectionHeader from './VehicleBlockSectionHeader';

export default VehicleBlockSectionHeader;
export { VehicleBlockSectionHeader };
